import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { MapRemixDrawer as Drawer, MapRemixDialog } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { ApplyFiltersInput } from './ApplyFiltersInput'
import { Form } from './Form'
import { IncludePropertiesInput } from './IncludePropertiesInput'
import { RemixButton } from './RemixButton'
import { WorkspaceSaveToInput } from './WorkspaceSaveToInput'

function MapRemixDrawer() {
  const { sideBar, drawerOpen } = useMapNavStore()

  const router = useRouter()

  const forceOpen = useMemo(
    () => router.query['remix'] === 'true',
    [router.query]
  )

  const [openDialog, setOpenDialog] = useState(false)
  const [status, setStatus] = useState<'loading' | 'completed' | 'idle'>('idle')
  const [redirect, setRedirect] = useState<string | undefined>(undefined)

  const handleClose = useCallback(() => {
    if (forceOpen) {
      const url = new URL(window.location.href)
      url.searchParams.delete('remix')
      router.replace(url.toString(), undefined, { shallow: true })
    }
  }, [forceOpen, router])

  const handleDialogOpen = useCallback(() => setOpenDialog(true), [])
  const handleDialogClose = useCallback(() => setOpenDialog(false), [])
  const handleActionClick = useCallback(() => setStatus('loading'), [])

  const handleSubmit = useCallback(() => {
    handleDialogOpen()
  }, [handleDialogOpen])

  const handleSubmitComplete = useCallback((event) => {
    setRedirect(event.redirect)
    setStatus('completed')
  }, [])

  useEffect(() => {
    if (redirect && status === 'completed') {
      setStatus('idle')
      setOpenDialog(false)
      router.push(redirect)
    }
  }, [redirect, status, router])

  useEffect(() => {
    if (sideBar === 'remix' && !drawerOpen) {
      handleClose()
    }
  }, [sideBar, drawerOpen, handleClose])

  return (
    <>
      <Drawer
        slots={{
          Form,
          ApplyFiltersInput,
          IncludePropertiesInput,
          WorkspaceSaveToInput,
          RemixButton
        }}
        slotProps={{
          Form: {
            onSubmit: handleSubmit,
            onSubmitComplete: handleSubmitComplete
          }
        }}
      />

      <MapRemixDialog
        loading={status === 'loading'}
        open={openDialog}
        onClose={handleDialogClose}
        onActionClick={handleActionClick}
      />
    </>
  )
}

export { MapRemixDrawer }
